/* global G */

/**
 * Dispatches G.DONE event with the current set of notes.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => () => {
  const { [G.EVENTS]: eventBus, [G.NOTE]: adapter } = app[G.ADAPTER]

  eventBus.dispatch(
    eventBus.type(G.NOTE, G.DONE),
    { [G.DATA]: adapter[G.DATA] },
  )
}

export default fn
